/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsGovernanceDissolvingNeuronsE8s1year } from "../../funcs/metricsGetApiV3MetricsGovernanceDissolvingNeuronsE8s1year.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsGovernanceDissolvingNeuronsE8s1yearRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsGovernanceDissolvingNeuronsE8s1year:
  ToolDefinition<typeof args> = {
    name: "metrics-get-api-v3-governance-dissolving-neurons-e8s-1year",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await metricsGetApiV3MetricsGovernanceDissolvingNeuronsE8s1year(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
